import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-blue-600 text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, " Código expira em: " + _toDisplayString(_ctx.minutes) + ":" + _toDisplayString(('0' + _ctx.seconds).slice(-2)), 1))
}